import React from 'react';

const DetailRow = ({ title, value, isHtml = false }) => (
  <div
    className={`tw-flex tw-w-full tw-gap-4 tw-py-3 tw-px-4 tw-border-b tw-border-solid tw-border-grey-200 tw-border-x-0 tw-border-t-0 last:tw-border-b-0 ${
      isHtml ? 'tw-flex-col' : ''
    }`}
  >
    <span
      className={`tw-text-lg tw-font-medium tw-text-grey-600 ${
        isHtml ? '' : 'tw-w-[240px] tw-shrink-0'
      }`}
    >
      {title}
    </span>
    {isHtml && value ? (
      <span
        className='tw-text-lg tw-font-medium tw-text-grey-800 tw-break-words wysiwyg-content'
        dangerouslySetInnerHTML={{ __html: value }}
      />
    ) : (
      <span className='tw-text-lg tw-font-medium tw-text-grey-800 tw-break-words tw-whitespace-pre-wrap'>
        {value != null && value !== '' ? value : '-'}
      </span>
    )}
  </div>
);

const SopDetails = ({ data }) => {
  if (!data) return null;

  const details = [
    { key: 'PID', value: data.pid },
    { key: 'Issue Type', value: data.issue_type },
    { key: 'Sub Issue Type', value: data.sub_issue_type },
    { key: 'Model Name', value: data.model_name && data.model_name !== 'null' ? data.model_name : null },
    { key: 'SOP', value: data.troubleshooting_steps, isHtml: true },
    { key: 'Created By', value: data.created_by },
    {
      key: 'Created At',
      value: data.install_ts ? new Date(data.install_ts * 1000).toLocaleString() : null,
    },
    { key: 'Updated By', value: data.updated_by },
    {
      key: 'Updated At',
      value: data.update_ts ? new Date(data.update_ts * 1000).toLocaleString() : null,
    },
  ];

  return (
    <div className='tw-border tw-border-solid tw-border-grey-200 tw-rounded-lg tw-bg-white tw-flex tw-flex-col'>
      {details.map((info) => (
        <DetailRow key={info.key} title={info.key} value={info.value} isHtml={info.isHtml} />
      ))}
    </div>
  );
};

export default SopDetails;
